import {
  Dialog,
  DialogContent,
  DialogTitle,
  V2Loader,
  VisuallyHidden,
} from "web-design-system";
import { getRouteApi, useRouter } from "@tanstack/react-router";
import { useSWP } from "creso-core/hooks";
import { AmcLogo } from "@core/components/logo/amc-logo";
import capitalize from "lodash/capitalize";
import { convertToCurrency } from "creso-core/utils";
import { format } from "date-fns";
import { PlanStatusBadge } from "web-core";

export function SwpDetails() {
  const clientRoute = getRouteApi("/(auth)/_headed/clients/$id");

  const { client } = clientRoute.useLoaderData();

  const portfolioRoute = getRouteApi("/(auth)/_headed/clients/$id/portfolio");

  const { id = "" } = portfolioRoute.useSearch();

  const { data: swpData, isLoading: isLoadingSwp } = useSWP({
    investmentAccountId: client?.investment_account ?? "",
    id: id as string,
  });

  const router = useRouter();

  return (
    <Dialog open onOpenChange={(open) => !open && router.history.back()}>
      <DialogContent>
        <VisuallyHidden>
          <DialogTitle>SWP Details</DialogTitle>
        </VisuallyHidden>
        <V2Loader isLoading={isLoadingSwp} className="flex flex-col">
          <div className="flex items-center pb-5 gap-4 border-b border-border">
            <AmcLogo
              size="sm"
              amc_code={swpData?.amc_morningstar_code ?? null}
            />
            <span className="text-base text-ellipsis overflow-hidden font-semibold mr-auto">
              {swpData?.scheme_name ?? ""}
            </span>
            <PlanStatusBadge status={swpData?.status ?? "ACTIVE"} />
          </div>
          <div className="py-4 flex flex-col gap-4">
            <span className="font-semibold text-sm">Withdrawal details</span>
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col gap-1">
                <span className="text-sm">Frequency</span>
                <span className="text-sm font-semibold">
                  {capitalize(swpData?.frequency) ?? "-"}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Amount</span>
                <span className="text-sm font-semibold">
                  {convertToCurrency(swpData?.installment_amount ?? 0)}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Start date</span>
                <span className="text-sm font-semibold">
                  {swpData?.start_date
                    ? format(swpData.start_date ?? "", "PP")
                    : "-"}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Next withdrawal</span>
                <span className="text-sm font-semibold">
                  {swpData?.installment_due_date
                    ? format(swpData?.installment_due_date ?? "", "PP")
                    : "-"}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Withdrawals completed</span>
                <span className="text-sm font-semibold">
                  {swpData?.no_of_withdrawals_completed ?? "-"}
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-sm">Total withdrawn via SWP</span>
                <span className="text-sm font-semibold">
                  {convertToCurrency(
                    swpData?.total_withdrawal_amount_completed ?? 0
                  )}
                </span>
              </div>
            </div>
          </div>
        </V2Loader>
      </DialogContent>
    </Dialog>
  );
}
